import { CommonModule, Location } from '@angular/common';
import { Component, Input, OnInit } from '@angular/core';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { DvlTrackingRecordPickUpModalComponent } from '../dvl-tracking-record-pick-up-modal/dvl-tracking-record-pick-up-modal.component';
import { ActivatedRoute, Router, RouterModule } from '@angular/router';
import { CustomProfileService } from 'src/app/core/services/custom-profile.service';
import { I18nModule, TranslationService } from '@spartacus/core';
import { CustomLandingModule } from '../../../custom-landing.module';
import { SharedModule } from 'src/app/shared/shared.module';
import { ToastrService } from 'ngx-toastr';
import { ShipmentVmsEblBlComponent } from '../../shipment-vms-ebl-bl/shipment-vms-ebl-bl.component';
import { CustomProductsService } from '../../../custom-products/custom-products.service';
import { pairwise } from 'rxjs';
import { AttatchmentModalComponent } from 'src/app/shared/components/attatchment-modal/attatchment-modal.component';
import { AttachInvoiceComponent } from '../../attach-invoice/attach-invoice.component';


@Component({
    selector: 'app-dvl-tracking-details',
    imports: [CustomLandingModule, CommonModule, RouterModule, I18nModule, SharedModule],
    templateUrl: './dvl-tracking-details.component.html',
    styleUrl: './dvl-tracking-details.component.scss'
})
export class DvlTrackingDetailsComponent implements OnInit {
  @Input() code: any;
  delData: any;
  clearenceValues: { id: string; Name: string; }[];
  deliveryDetailsData: any;
  batchCompFlag;
  enableLoader: boolean = true;
  dvldDetails: any;
  title: any = '';
  navigationData: string = '';
  pathTitle: string = '';
  state: any;
  id: any
  list: any = {};
  passingArray: any = {};
  isAgentInvoiceActive: string = 'false';
  constructor(private location: Location, private customProfileService: CustomProfileService,
    private activatedRoute: ActivatedRoute, private toastrService: ToastrService,
    private router: Router, private route: ActivatedRoute, public modalService: NgbModal,
    private customprofile: CustomProfileService, private translation: TranslationService,
    private customproductservice:CustomProductsService, private customProductService:CustomProductsService
  ) {
    // this.state = location.getState();

    // this.id = this.route.snapshot.paramMap.get('id');
    // this.passingArray = {
    //   baseProductCode: this.state.baseProductCode,
    //   batchId: this.id,
    // }

  }
  ngOnInit(): void {
    this.customProductService.returnAgentInvoiceActive().subscribe(res=>{
      this.isAgentInvoiceActive = res;
   })
    this.enableLoader = true;
    this.clearenceValues = [
      { id: 'yes', Name: 'YES' },
      { id: 'no', Name: 'NO' }
    ];
    this.id = this.route.snapshot.paramMap.get('id');
    this.passingArray = {
      baseProductCode: this.route.snapshot.queryParams.baseProductCode,
      batchId: this.id,
    }
    this.getDeliverydetails()

    this.translation
      .translate('breadcrumb.batchDetail.pageTitle')
      .subscribe(res => {
        this.title = res;
      });
    this.translation
      .translate('breadcrumb.batchDetail.pageDetailTitle')
      .subscribe(res => {
        this.pathTitle = res;
      });
    this.translation
      .translate('breadcrumb.batchDetail.breadcrumb')
      .subscribe(res => {
        this.navigationData = res;
      });
    
    this.customProductService.languageChange$.pipe(pairwise()).subscribe(([previous, current]) => {
      this.enableLoader = true;
      if (current != null) {
        if (previous !== current) {
          this.getDeliverydetails();
        }
      }
    })
  }
 
  getDeliverydetails() {   
    this.enableLoader = true;
    let toastshown=false;
    this.customProfileService.dvlTrackingDetails(this.passingArray).subscribe((data) => {
      this.enableLoader = false;
      if (data) {
        this.dvldDetails = data;
        this.batchCompFlag = this.dvldDetails.isBatchCompleted;

      }
      else {
        this.translation.translate('shipment.emptyerrormessage').subscribe(res=>{   
          if(!toastshown){
            this.toastrService.show(res);
            toastshown=true;
          }
        })
      }
    }, err => {
      this.translation.translate('shipment.erroroccuredmessage').subscribe(res=>{   
        if(!toastshown){
          this.toastrService.show(res);
          toastshown=true;
        }
      })
      this.enableLoader = false;
    })
  }
  shipData(shipData: any) {
    throw new Error('Method not implemented.');
  }
  backToDeliveryList() {
    this.router.navigate(['batches/dvl-tracking-list'], {queryParams:{from:'details'},skipLocationChange: false })
  }
  checkBatchCompleted(flag) {
    let toastshown = false;
    if (flag == 'no') {
      this.batchCompFlag = false;
    } else {
      const nominationDataForDelivery = this.dvldDetails.nominationItems.filter(function(val) {
        return val.isDeliveryCompleted == false
      });
      
      if(nominationDataForDelivery.length === 0){
        this.batchCompFlag = true;
        const modalRef = this.modalService.open(ShipmentVmsEblBlComponent, { centered: true, size: 'lg' });
        modalRef.componentInstance.shipData = this.dvldDetails;
        modalRef.componentInstance.modalToOpen = 'batchCompleted';
        modalRef.componentInstance.flag = this.batchCompFlag;
        modalRef.result.then(res=>{
            if(res=='success'){
              this.getDeliverydetails();
            }
        })
      }else{
        this.batchCompFlag = false;
          this.translation.translate('shipment.chkBeforeBatchComplete').subscribe(res=>{   
          if(!toastshown){
            this.toastrService.show(res);
            toastshown=true;
          }
        })
      }
      
    }
  }

  recordPickUpModal(data) {
    const ModalRef = this.modalService.open(DvlTrackingRecordPickUpModalComponent, { 
    centered: true, size: 'lg',
    backdrop: 'static',
    keyboard: false, });
    ModalRef.componentInstance.nominationData = data;
    ModalRef.componentInstance.deliveryDetails = this.dvldDetails;
    ModalRef.componentInstance.isInvoiceCreationSuccess = data?.isInvoiceCreationSuccess;
    ModalRef.componentInstance.azureValidationRemark = data?.azureValidationRemark;
    ModalRef.componentInstance.passingArray = this.passingArray;
    ModalRef.componentInstance.azureStatus = data?.azureStatus;
    ModalRef.result.then(res=>{
              this.getDeliverydetails();
          })
 
  }
  goToAttachment(){
    const ModalRef = this.modalService.open(AttatchmentModalComponent, { centered: true, size: 'lg' });
          ModalRef.componentInstance.batchDeliveryData = this.dvldDetails;
          ModalRef.componentInstance.fromComponent = 'batchDeliveryDetails';
          ModalRef.result.then(res=>{
            if(res=='success'){
              this.getDeliverydetails();
            }
          })
  }
 openInvoices(data: any){
      const modalref = this.modalService.open(AttachInvoiceComponent, {
        centered: true,
        size: 'lg',
        backdrop: 'static',
        keyboard: false,
      });
    modalref.componentInstance.display='invoices';
    modalref.componentInstance.batchData = data;
    modalref.componentInstance.useCaseType = 'CARGODELIVERYINVOICE_UC3';

  }
}
